import { render } from "./index.vue?vue&type=template&id=55dfa5ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=55dfa5ee&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dfa5ee"]])

export default __exports__